<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      style="width: 400px; max-width: 100%;"
    >
      <q-form
        ref="formRef"
      >
        <q-card-section class="row items-center q-mx-xs">
          <div class="text-h6">
            Polaris Export
          </div>
          <q-space />
          <q-btn
            v-close-popup
            icon="close"
            flat
            round
            dense
          />
        </q-card-section>
        <q-card-section>
          <div>
            <q-select
              v-model="selectedPolarisType"
              label="Polaris Type"
              :options="$mh.asOptions(POLARIS_EXPORT_TYPES)"
              map-options
              emit-value
              :rules="[val => !!val || 'A Polaris type is required']"
            />
          </div>
          <div
            v-if="selectedPolarisType !== POLARIS_EXPORT_TYPES.PRODUCT_CODES"
            class="q-mt-md"
          >
            <iso-date-input
              v-model="date"
              emit-string="allow-blank"
              class="col-6"
              label="Export Date"
              bottom-slots
              :rules="[val => !!val || 'Date is required']"
            />
          </div>
        </q-card-section>
        <q-card-actions

          class="row justify-end q-ma-sm"
        >
          <q-btn
            label="Download"
            color="primary"
            @click="downloadExport()"
          />
        </q-card-actions>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import { Notify } from 'quasar'
import { serverUri } from 'src/config'
import { IsoDate } from 'src/models/model'
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'
import FormValidationMixin from 'src/modules/admin/mixins/FormValidationMixin'

export const POLARIS_EXPORT_TYPES = {
  PRODUCT_CODES: 'product_codes',
  CONCESSION_SALES: 'sales',
  STOCK_SALES: 'stock_sales'
}

export default {
  name: 'PolarisExportDialog',
  components: {
    IsoDateInput
  },
  mixins: [FormValidationMixin],
  configuration: ['currentSite'],
  data () {
    return {
      selectedPolarisType: POLARIS_EXPORT_TYPES.PRODUCT_CODES,
      date: null,
      shown: false
    }
  },
  created () {
    _.extend(this, { IsoDate, POLARIS_EXPORT_TYPES })
  },
  methods: {
    show () {
      this.shown = true
    },
    buildUri () {
      return `${serverUri}/polaris/${this.selectedPolarisType}?download=true&site_id=${this.currentSite.id}&date=${this.date}`
    },
    downloadExport () {
      this.validateForm(() => {
        window.location.href = this.buildUri()

        Notify.create({
          message: 'Download Started',
          position: 'top',
          type: 'positive'
        })
        this.shown = false
      })
    }
  }
}

</script>
